import React from 'react';

import classnames from '../../../../core/utils/classnames.tsx';

const VARIANT_CLASSES = {
    default: 'bg-surface-strong text-content-strong',
    success: 'bg-surface-success-weak text-content-success-strong',
    danger: 'bg-surface-danger-weak text-content-danger-strong',
    muted: 'bg-surface-medium text-content-medium',
} as const;

export type ChipVariant = keyof typeof VARIANT_CLASSES;

const Chip = ({ variant = 'default', children }: { variant?: ChipVariant; children: React.ReactNode }) => (
    <span
        className={classnames(
            'px-2 py-0.5 text-xs rounded-full whitespace-nowrap inline-flex items-center',
            VARIANT_CLASSES[variant]
        )}
    >
        {children}
    </span>
);

export default Chip;
